import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/pro-solid-svg-icons';

function LoadingPlaceHolder({ isVisible }) {
  if (isVisible) {
    return (
      <div className="text-center py-5">
        <FontAwesomeIcon
          icon={faCircleNotch}
          spin
          size="3x"
          style={{ color: '#953263' }}
        />
      </div>
    );
  }

  return null;
}

LoadingPlaceHolder.defaultProps = {
  isVisible: true,
};

LoadingPlaceHolder.propTypes = {
  isVisible: PropTypes.bool,
};

export default LoadingPlaceHolder;
